import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CloseIcon from '../../icons/close.svg';

class ConfirmDialogue extends Component {
    constructor(props) {
        super(props);
        this.modal = document.createElement('div');
        this.modalsRoot = document.getElementById('globalModals');

        this.handleOutsideClick = () => {
            this.props.onClose();
        }
    }

    componentDidMount() {
        this.modalsRoot.appendChild(this.modal);
    }

    componentWillUnmount() {
        this.modalsRoot.removeChild(this.modal);
    }

    render() {
        const { header, text, buttonTextCancel, buttonTextConfirm, onClose, onConfirm } = this.props;
        return ReactDOM.createPortal(
            <div className='confirm-dialogue' onClick={this.handleOutsideClick}>
                <div className='confirm-dialogue-content'>

                    <div className='confirm-dialogue-content__header'>
                        <h4>{header}</h4>
                        <CloseIcon className='icon-small' onClick={onClose} />     
                    </div>
                    <div className='confirm-dialogue-content__text'>
                        <p>{text}</p>
                    </div>
                    <div className="confirm-dialogue-content__button-wrapper">
                    <button onClick={onClose} className='confirm-dialogue-content__button confirm-dialogue-content__button--cancel'>{buttonTextCancel}</button>
                    <button onClick={onConfirm} className='confirm-dialogue-content__button confirm-dialogue-content__button--confirm'>{buttonTextConfirm}</button>
                    </div>
                </div>
            </div>
            , this.modal);
    }
}


export default ConfirmDialogue;